import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import esDict from "@/i18n/ar.json";

export default function ThankYou() {
  const t = (path) =>
    path.split(".").reduce((a, k) => (a ? a[k] : undefined), esDict);

  useEffect(() => {
    document.documentElement.lang = "es-AR";
    document.title = "Habitaloro | " + t("thankYou.title");
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#F8F9FA]">
      <header className="w-full bg-white border-b border-slate-200">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center">
          <Link to="/" className="flex items-center gap-3" data-testid="thankyou-logo">
            <span
              aria-hidden="true"
              className="inline-flex h-9 w-9 items-center justify-center rounded-sm bg-slate-900 text-white font-serif text-lg"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              H
            </span>
            <span
              className="text-lg text-slate-900 font-medium"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {t("header.logoName")}
            </span>
          </Link>
        </div>
      </header>
      <main className="flex-1 flex items-center">
        <div className="mx-auto max-w-2xl w-full px-6 lg:px-10 py-24 text-center">
          <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-[#C25934]/10 mb-8">
            <CheckCircle2 className="text-[#C25934]" size={40} />
          </div>
          <span className="text-xs tracking-[0.24em] uppercase text-[#C25934] font-semibold">
            {t("thankYou.overline")}
          </span>
          <h1
            data-testid="thankyou-title"
            className="mt-4 text-4xl lg:text-5xl text-slate-900 tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {t("thankYou.title")}
          </h1>
          <p className="mt-6 text-slate-700 leading-relaxed">
            {t("thankYou.text")}
          </p>
          <p className="mt-4 text-sm text-slate-500 leading-relaxed">
            {t("thankYou.note")}
          </p>
          <div className="mt-10">
            <Button
              asChild
              data-testid="thankyou-back-home"
              className="rounded-sm bg-slate-900 hover:bg-slate-800 text-white h-11 px-8"
            >
              <Link to="/">{t("thankYou.back")}</Link>
            </Button>
          </div>
        </div>
      </main>
      <footer className="bg-slate-900 text-slate-400 py-10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 text-xs text-center">
          {t("footer.copyright")}
        </div>
      </footer>
    </div>
  );
}
